import React from "react";
import styled from "styled-components";
import Alert from "@atlas/uicorn/lib/Data/Alert";
import InfoIcon from "@atlas/uicorn/lib/Icon/InfoIcon";
import Text from "@atlas/uicorn/lib/Display/Text";
import ArrowIcon from "@atlas/uicorn/lib/Icon/ArrowIcon";
import t from "../../../texts/t";

function LoginAlert({ language, loginUrl }: TLoginAlertProps) {
  return (
    <SAlert
      icon={<InfoIcon />}
      message={
        <SMessage>
          <Text>
            {t("If you are a customer, login to view your tickets.", language)}
          </Text>
          <SLink href={loginUrl}>
            {t("Login", language)}
            <ArrowIcon dir="up-right" />
          </SLink>
        </SMessage>
      }
    />
  );
}

export default LoginAlert;

// #region Styles

const SAlert = styled(Alert)`
  margin: 12px 0;
`;

const SMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SLink = styled.a`
  display: flex;
  font: ${(p) => p.theme.font.normal};
  color: ${(p) => p.theme.color.primary};

  &:visited,
  &:hover,
  &:active {
    color: ${(p) => p.theme.color.primary};
  }
`;

// #endregion

// #region Types

type TLoginAlertProps = {
  language?: string;
  loginUrl: string;
};

// #endregion
